import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { appRoutes } from 'constants/appRoutes';
import { BsExclamationTriangleFill, BsX } from "react-icons/bs";
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { BsPersonFill } from "react-icons/bs";
import { BiPlus } from "react-icons/bi";
import { userService } from 'services/userService';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { allowNumber } from 'utils/inputValidator';

const UserForm = () => {
    const [isEditForm, setIsEditForm] = useState();
    const [isLoader, setIsLoader] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    const [message, setMessage] = useState();
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        mobileNo: '',
        email: '',
        roleId: '',
        isActive: true
    });

    useEffect(() => {
        setIsEditForm(() => (id ? true : false))

        if (id > 0) {
            setIsLoader(true);
            userService.getUser(apiUrls.getUser(id)).then((res) => {
                setIsLoader(false);
                setUser(res)
            }).catch((err) => setIsLoader(false));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "mobileNo" && !allowNumber(e.target.value)) { return; }

        setUser((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage();
        if (validateForm()) {
            setIsLoader(true);
            if (isEditForm) {
                userService.updateUser(apiUrls.updateUser(id), user).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.info("User updated successfully!");
                        navigate(appRoutes.users);
                    } else {
                        setMessage("User already exists!");
                    }
                }).catch((err) => setIsLoader(false));
            } else {
                userService.addUser(apiUrls.addUser(), user).then((res) => {
                    setIsLoader(false);
                    if (res === true) {
                        toast.info("User added successfully!");
                        navigate(appRoutes.users);
                    } else {
                        setMessage("User already exists!");
                    }
                }).catch((err) => setIsLoader(false));
            }
        }
    }

    const validateForm = () => {
        setMessage();
        if (!user.firstName
            || !user.lastName
            || !user.username
            || !user.mobileNo
            || !user.roleId
            || (!user.password && !isEditForm)) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={5}>
                    <Card className='card-default'>
                        <Card.Body>
                            {isLoader && <ProgressLoader />}
                            <Card.Title>
                                <BsPersonFill size={24} /> {isEditForm ? 'Edit' : 'New'} User
                            </Card.Title>
                            <Form onSubmit={handleSubmit} noValidate>
                                {message && (
                                    <Alert variant='danger'>
                                        <BsExclamationTriangleFill /> {message}
                                    </Alert>
                                )}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">First Name*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={20}
                                            name='firstName'
                                            value={user.firstName}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Last Name*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={20}
                                            name='lastName'
                                            value={user.lastName}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Username*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={20}
                                            name='username'
                                            value={user.username}
                                            onChange={handleChange}
                                            disabled={isEditForm} />
                                    </Col>
                                </Form.Group>
                                {!isEditForm &&
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Password*</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="password"
                                                maxLength={20}
                                                name='password'
                                                value={user.password}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                }
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Mobile No*</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="text"
                                            maxLength={10}
                                            name='mobileNo'
                                            value={user.mobileNo}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">Email ID:</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="email"
                                            maxLength={50}
                                            name='email'
                                            value={user.email}
                                            onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="3">User Role*</Form.Label>
                                    <Col sm="9">
                                        <Form.Select
                                            aria-label="Default select example"
                                            name='roleId'
                                            value={user.roleId}
                                            onChange={handleChange}>
                                            <option value=""></option>
                                            <option value="1">SuperAdmin</option>
                                            <option value="2">Admin</option>
                                            <option value="3">Staff</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                {isEditForm && (
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Active:</Form.Label>
                                        <Col sm="9">
                                            <Form.Check
                                                type="checkbox"
                                                name='isActive'
                                                checked={user.isActive}
                                                onChange={handleChange}
                                                label="" />
                                        </Col>
                                    </Form.Group>
                                )}
                                <Form.Group as={Row}>
                                    <Col sm={{ span: 9, offset: 3 }}>
                                        <Button type="submit" variant='primary' className='mw-100'>
                                            <BiPlus size={20} /> {isEditForm ? 'Update' : 'Add'}
                                        </Button>
                                        <Button
                                            type="button"
                                            variant='secondary'
                                            className='ms-3 mw-100'
                                            onClick={() => navigate(appRoutes.users)}>
                                            <BsX size={20} /> Cancel
                                        </Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default UserForm;